import React, { useEffect, useState } from "react"
import { useAdditionalTestingStore, useAuthStore } from "../../stores/StoreProvider"
import { observer } from "mobx-react-lite"
import { Button, Col, Collapse, Offcanvas, Row, Toast, ToastBody, ToastContainer } from "react-bootstrap"
import { ChevronCompactLeft } from "react-bootstrap-icons"
import useBottomReached from "../../hooks/useBottomReached"

export function AdvertisementBanner() {
  const additionalTestingStore = useAdditionalTestingStore()
  const authStore = useAuthStore()
  const advertisement = additionalTestingStore.additionalTesting?.advertisement
  const personalized = additionalTestingStore.additionalTesting?.personalized
  const donorName = authStore.donorInfo?.firstName?.toLowerCase() ?? ""
  const [minimized, setMinimized] = useState(true)
  const atBottom = useBottomReached()

  const className = minimized ? "position-fixed collapsed" : "position-fixed"

  useEffect(() => {
    if (atBottom) {
      setMinimized(false)
    }
  }, [atBottom])

  const previouslyOrdered = additionalTestingStore.additionalTesting?.previouslyOrdered
  const hasAvailablePanels = additionalTestingStore.additionalTesting?.hasAvailablePanels
  const qns = additionalTestingStore.additionalTesting?.qns
  if (!advertisement || previouslyOrdered || !hasAvailablePanels || qns) {
    return <></>
  }

  return <>
    {/* <Offcanvas name="offcanvas" show={atBottom} placement={"bottom"} scroll backdrop={false}>
      <Offcanvas.Header>
        {!!advertisement.title && <Offcanvas.Title>{advertisement.title}</Offcanvas.Title>}
      </Offcanvas.Header>
      <Offcanvas.Body>
        {personalized && donorName.length > 0 ? <span className="text-capitalize">{donorName},&nbsp;</span> : <></>}
        {advertisement.bodyText}
        <div className="position-absolute bottom-0 end-0 pb-2 pe-2">
          <Button variant="primary" onClick={() => { setMinimized(true); additionalTestingStore.setShowCart(true) }}>{advertisement.continueButton}</Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas> */}
    <Offcanvas show={!minimized/* && !atBottom*/} placement="end" scroll backdrop onHide={() => setMinimized(true)} backdropClassName="additional-testing-advertisement-backdrop" className="additional-testing-advertisement m-auto w-md-50 fit-content">
      <Offcanvas.Header className="pb-0">
        {!!advertisement.title && <Offcanvas.Title>{advertisement.title}</Offcanvas.Title>}
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column">
        {personalized && donorName.length > 0 ? <span className="text-capitalize">{donorName},</span> : <></>}
        <Row><Col>{advertisement.bodyText}</Col></Row>

        <Row className="mt-auto align-self-stretch pt-2 justify-content-center">
          <Col className="text-center">
            <Button
              variant="info"
              className="additional-testing-action-button btn mb-2"
              onClick={() => {
                setMinimized(true)
                additionalTestingStore.setShowCart(true)
              }}
            >
              {advertisement.continueButton}
            </Button>

            <Button
              variant="info"
              className="additional-testing-action-button btn mb-2"
              onClick={() => setMinimized(true)}
            >
              {advertisement.notNowButton}
            </Button>
          </Col>
        </Row>

      </Offcanvas.Body>
    </Offcanvas>
    <ToastContainer position="middle-end" className={className}>
      {minimized && <Toast animation delay={1000} transition={Collapse} show={!atBottom} className={minimized ? "additional-testing-slider w-auto" : "additional-testing-slider"}>
        <ToastBody>
          {!!advertisement.title && <div className="vertical-text-pointer" onClick={() => setMinimized(false)}>{advertisement.title}</div>}
          {!advertisement.title && <ChevronCompactLeft height={200} onClick={() => setMinimized(false)} style={{ fontWeight: "bolder", transform: "scaleY(3.0)" }} />}
        </ToastBody>
      </Toast>}
    </ToastContainer>
  </>
}

export default observer(AdvertisementBanner)
